// extracted by mini-css-extract-plugin
module.exports = {"cast-item":"CastItem_cast-item__2qvdF","cast-img":"CastItem_cast-img__37AAc"};